import Error from './error'
export default Error



// WEBPACK FOOTER //
// ./src/components/error/index.js